/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-09 18:39:55
 */ 
import {mainCn} from "./main/mainCn.js";
import {oneTypeDetailCn} from "./oneTypeDetail/oneTypeDetailCn.js";
import {serviceDetailCn} from "./serviceDetail/serviceDetailCn.js";
import {serviceListCn} from "./serviceList/serviceListCn.js";
import {settleCn} from "./settle/indexCn.js";
import {consultationOrderDetailCn} from "./consultationOrderDetail/indexCn.js";
import {expertCn} from "./expert/indexCn.js";
import {InquirySheetDetailsCn} from "./InquirySheetDetails/indexCn.js";
import {expertStepCn} from "./expertStep/indexCn.js";
import {trainListCn} from "./trainList/indexCn.js";
import {trainHomeCn} from "./trainHome/indexCn.js";
import {trainVipCn} from "./trainVip/indexCn.js";
import {trainViewCn} from "./trainView/indexCn.js";
import {trainBuyingCn} from "./trainBuying/indexCn.js";
import {settleStepCn} from "./settleStep/indexCn.js";
import {expertListCn} from "./expertList/indexCn.js";
import {expertBuyOrderCn} from "./expertBuyOrder/indexCn.js";
import {expertPayOrderCn} from "./expertPayOrder/indexCn.js";
import {expertConsultationChatCn} from "./expertConsultationChat/indexCn";
import {fillapplicationCn} from "./selfHelpFillapplication/indexCn";
import {paymentCn} from './payment/indexCn';
import {registerCn} from "./register/indexCn";
import {channelCn} from "./channel/channelCn";
import {databaseCn} from "./database/indexCn";

export const homeCn = {
    mainLang:mainCn,
    oneTypeDetailLang:oneTypeDetailCn,
    serviceDetailLang:serviceDetailCn,
    serviceListLang: serviceListCn,
    settleHomeLang:settleCn,
    consultationOrderDetailLang:consultationOrderDetailCn,
    expertLang:expertCn,
    expertStepLang:expertStepCn,
    InquirySheetDetailsLang: InquirySheetDetailsCn,
    trainListLang:trainListCn,
    trainHomeLang:trainHomeCn,
    trainVipLang:trainVipCn,
    trainViewLang:trainViewCn,
    trainBuyingLang:trainBuyingCn,
    settleStepLang:settleStepCn,
    expertListLang:expertListCn,
    expertBuyOrderLang:expertBuyOrderCn,
    expertPayOrderLang:expertPayOrderCn,
    expertConsultationChatLang:expertConsultationChatCn,
    fillapplicationLang:fillapplicationCn,
    paymentLang:paymentCn,
    registerLang:registerCn,
    channelLang:channelCn,
    databaseLang:databaseCn
}


// WEBPACK FOOTER //
// ./src/lang/home/homeCn.js